import {
  HTTP_DEPARTMENTSPECIAL_FETCHING,
  HTTP_DEPARTMENTSPECIAL_SUCCESS,
  HTTP_DEPARTMENTSPECIAL_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_DEPARTMENTSPECIAL_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_DEPARTMENTSPECIAL_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_DEPARTMENTSPECIAL_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
